import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"
Chart.register(...registerables)

export default class extends Controller {
    static targets = ["canvas"]
    static values = {
        bookingsData: Object,
        visitsData: Object,
        bookingsLabel: String,
        visitsLabel: String
    }

    connect() {
        this.renderChart()
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy()
        }
    }

    renderChart() {
        const ctx = this.canvasTarget.getContext("2d")

        // Gradients
        const gradientBookings = ctx.createLinearGradient(0, 0, 0, 400)
        gradientBookings.addColorStop(0, "rgba(79, 70, 229, 0.2)")
        gradientBookings.addColorStop(1, "rgba(79, 70, 229, 0)")

        const gradientVisits = ctx.createLinearGradient(0, 0, 0, 400)
        gradientVisits.addColorStop(0, "rgba(148, 163, 184, 0.1)")
        gradientVisits.addColorStop(1, "rgba(148, 163, 184, 0)")

        // Merge labels from both datasets to ensure complete X axis
        const allLabels = [...new Set([
            ...Object.keys(this.bookingsDataValue),
            ...Object.keys(this.visitsDataValue)
        ])].sort()

        const bookingsValues = allLabels.map(label => this.bookingsDataValue[label] || 0)
        const visitsValues = allLabels.map(label => this.visitsDataValue[label] || 0)

        this.chart = new Chart(ctx, {
            type: "line",
            data: {
                labels: allLabels,
                datasets: [
                    {
                        label: this.bookingsLabelValue,
                        data: bookingsValues,
                        borderColor: "#4f46e5",
                        backgroundColor: gradientBookings,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 3,
                        pointBackgroundColor: "#fff",
                        pointBorderColor: "#4f46e5",
                        pointBorderWidth: 2,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        zIndex: 2
                    },
                    {
                        label: this.visitsLabelValue,
                        data: visitsValues,
                        borderColor: "#94a3b8",
                        backgroundColor: gradientVisits,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        borderDash: [5, 5],
                        pointBackgroundColor: "#fff",
                        pointBorderColor: "#94a3b8",
                        pointBorderWidth: 1,
                        pointRadius: 3,
                        pointHoverRadius: 5,
                        zIndex: 1
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    intersect: false,
                    mode: 'index',
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        backgroundColor: "#1e293b",
                        padding: 12,
                        titleFont: { size: 12, weight: 'bold' },
                        bodyFont: { size: 14 },
                        cornerRadius: 12,
                        displayColors: true,
                        boxWidth: 8,
                        boxHeight: 8,
                        usePointStyle: true
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: "#94a3b8",
                            font: { size: 10, weight: 'bold' },
                            maxRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: 10
                        }
                    },
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: "rgba(241, 245, 249, 1)",
                            drawBorder: false
                        },
                        ticks: {
                            color: "#94a3b8",
                            font: { size: 10, weight: 'bold' }
                        }
                    }
                }
            }
        })
    }
}
